import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { TOASTER_TYPES } from 'data/ui/selectors'
import {
  CloseIcon,
  WarningIcon,
  CheckMarkIcon,
  ForbiddenIcon,
  InfoIcon,
} from 'components/Utils/Icons'

const BORDER_CLASS_BY_TYPE = {
  [TOASTER_TYPES.INFO]: 'border-teal',
  [TOASTER_TYPES.SUCCESS]: 'border-green',
  [TOASTER_TYPES.WARNING]: 'border-yellow',
  [TOASTER_TYPES.ERROR]: 'border-red',
}

const COLOR_CLASS_BY_TYPE = {
  [TOASTER_TYPES.INFO]: 'teal',
  [TOASTER_TYPES.SUCCESS]: 'green',
  [TOASTER_TYPES.WARNING]: 'yellow',
  [TOASTER_TYPES.ERROR]: 'red',
}

const ICON_BY_TYPE = {
  [TOASTER_TYPES.INFO]: InfoIcon,
  [TOASTER_TYPES.SUCCESS]: CheckMarkIcon,
  [TOASTER_TYPES.WARNING]: WarningIcon,
  [TOASTER_TYPES.ERROR]: ForbiddenIcon,
}

export default class ToasterItem extends Component {
  static propTypes = {
    type: PropTypes.oneOf(Object.keys(TOASTER_TYPES)).isRequired,
    title: PropTypes.string.isRequired,
    detail: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    renderAction: PropTypes.func,
  }

  // Let's keep track of the closing timeout handle.
  closeTimeout = null

  componentDidMount() {
    this.closeTimeout = setTimeout(() => {
      this.onClose()
    }, 5 * 1000 /* 5s */)
  }

  componentWillUnmount() {
    clearTimeout(this.closeTimeout)
  }

  onClose = () => {
    clearTimeout(this.closeTimeout)
    this.props.onClose()
  }

  render() {
    const { type, title, detail, renderAction } = this.props
    const Icon = ICON_BY_TYPE[type]

    return (
      <div
        style={{
          borderLeftWidth: 4,
          borderLeftStyle: 'solid',
          maxWidth: 580,
        }}
        className={classNames(
          [
            'color-mode-elevated',
            'position-relative',
            'shadow-hovering',
            'padding-vertical-large padding-left-large padding-right-larger',
            'shade-05 background-shade-100 radius-normal',
          ],
          BORDER_CLASS_BY_TYPE[type]
        )}
      >
        <div className="flexbox flexbox-align-center margin-bottom-small">
          <Icon
            style={{ width: 16, height: 16 }}
            className={classNames(
              COLOR_CLASS_BY_TYPE[type],
              'margin-right-small',
              'flexbox-no-shrink flexbox-no-grow'
            )}
          />
          <div className="font-size-large font-weight-semibold">{title}</div>
        </div>
        {detail && <div className="margin-bottom-small">{detail}</div>}
        {renderAction && renderAction({ type, detail, title })}

        <div
          onClick={this.onClose}
          className="position-absolute pointer shade-30 shade-20-on-hover"
          style={{ top: 12, right: 12 }}
        >
          <CloseIcon size={12} />
        </div>
      </div>
    )
  }
}
